function getPredictionDetails(state, matchid) {

    /*return isAnswer && state.predictionAnswer.filter((pa) => pa.matchid === matchid)[0] !== undefined ?
                state.predictionAnswer.filter((pa) => pa.matchid === matchid)[0] : 
           !isAnswer && state.prediction.filter((p) => p.matchid === matchid)[0] !== undefined ? 
                state.prediction.filter((p) => p.matchid === matchid)[0] : 
                {}*/
     
     return state.prediction.filter((p) => p.matchid === matchid)[0] !== undefined ? 
               state.prediction.filter((p) => p.matchid === matchid)[0] : 
               {}

}

export default getPredictionDetails